import { render, staticRenderFns } from "./kr-field.vue?vue&type=template&id=09527344&scoped=true&"
import script from "./kr-field.vue?vue&type=script&lang=js&"
export * from "./kr-field.vue?vue&type=script&lang=js&"
import style0 from "./kr-field.vue?vue&type=style&index=0&id=09527344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09527344",
  null
  
)

export default component.exports